import { css } from "@emotion/react";

export function notFoundCSS(){
    return css`
    
    `;
}